import React from 'react';
import styled from 'styled-components';
import DropdownMenu from './DropdownMenu';
export const Wrapper = styled.div `
  position: relative;
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
export const ValueText = styled.p `
  margin: 0 8px;
  font-size: ${(props) => props.theme.fontSmall};
`;
export class StandardSelect extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            value: this.props.initialValue,
            isMenuOpen: false,
        };
        this.onClick = (e) => {
            const { value, isMenuOpen } = this.state;
            this.setState({
                value: (e && e.target && e.target.value) || value,
                isMenuOpen: !isMenuOpen,
            });
        };
        this.onCloseMenu = () => {
            this.setState({
                isMenuOpen: false,
            });
        };
    }
    render() {
        const { id, idDropdown, values, notOpenSection } = this.props;
        const { isMenuOpen, value } = this.state;
        return (React.createElement(Wrapper, { id: id, onClick: this.onClick, className: "standard-select" },
            notOpenSection(isMenuOpen, value),
            isMenuOpen && (React.createElement(DropdownMenu, { id: idDropdown, direction: DropdownMenu.Direction.BOTTOM_LEFT, open: isMenuOpen, onClose: this.onCloseMenu }, values.map((o, index) => (React.createElement(DropdownMenu.Item, Object.assign({ id: `${idDropdown}-${o.value}`, className: `language-item-${o.value}`, key: o.label + index, value: o.value, isSelected: value === o.value }, o.optionProps), o.label)))))));
    }
}
export default StandardSelect;
